import { createI18n } from 'vue-i18n'
import en from '../../localization/en/en.json'
import ar from '../../localization/ar/ar.json'
import es from '../../localization/es/es.json'
import de from '../../localization/de/de.json'
import it from '../../localization/it/it.json'
import fr from '../../localization/fr/fr.json'
import pt from '../../localization/pt/pt.json'
import el from '../../localization/el/el.json'
import bn from '../../localization/bn/bn.json'
import sr from '../../localization/sr/sr.json'
import cs from '../../localization/cs/cs.json'
import pl from '../../localization/pl/pl.json'
import hu from '../../localization/hu/hu.json'
import sk from '../../localization/sk/sk.json'
import ro from '../../localization/ro/ro.json'
import bg from '../../localization/bg/bg.json'
import mk from '../../localization/mk/mk.json'
import sq from '../../localization/sq/sq.json'
import { DEFAULT_LOCALE } from './i18n.constants'
import numberFormats from './rules/numbers'
import datetimeFormats from './rules/datetime'
import pluralRules from './rules/pluralization'

export * from './i18n.constants'
export * from './i18n.types'

export default createI18n({
  legacy: false,
  locale: DEFAULT_LOCALE.code,
  globalInjection: true,
  messages: {
    en,
    ar,
    es,
    de,
    it,
    fr,
    pt,
    el,
    bn,
    sr,
    cs,
    pl,
    hu,
    sk,
    ro,
    bg,
    mk,
    sq,
  },
  pluralRules,
  numberFormats,
  datetimeFormats,
  fallbackLocale: DEFAULT_LOCALE.code,
})
